<template>
  <div class="bs-wrapper" :style="{ height: stageHeight + 'px' }">
    <!-- 后台编辑的定制活动 -->
    <div class="activity-wrapper" v-if="way == 1">
      <div class="section3 flex-col">
        <div class="main1 flex-col">
          <div class="main2 flex-col">
            <div class="section4 flex-col">
              <van-image class="head-img" :src="headDiagram" />
            </div>
          </div>
          <div class="main3 flex-row">
            <span class="word3">活动名称</span>
            <span class="info3">{{ name }}</span>
          </div>
          <div class="main3 flex-row">
            <span class="word3">活动时间</span>
            <span class="info3">{{ startTime }}&nbsp;~&nbsp;{{ endTime }}</span>
          </div>
          <div class="main3 flex-row">
            <span class="word3">活动地点</span>
            <span class="info3">{{ address }}</span>
          </div>
          <div class="main6 flex-row">
            <span class="word7">活动详情</span>
            <span class="word8" v-html="detail"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Image, Toast } from 'vant';
import { mapState } from 'vuex';

import { getDetail } from '@/api/activity';

export default {
  name: 'plazaActivityDetail',

  mixins: [],

  components: {
    [Image.name]: Image,
  },

  props: {},

  data() {
    return {
      id: 1,
      // 活动名称
      name: '',
      // 活动详情
      detail: '',
      // 开始时间
      startTime: '',
      // 结束时间
      endTime: '',
      // 活动头图
      headDiagram: '',
      // 活动链接
      link: '',
      // 活动地址
      address: '',
      // way：1 自定义内容 2是链接
      way: 1,
    };
  },

  computed: {
    ...mapState({
      stageHeight: state => state.base.stageHeight,
    }),
  },

  watch: {},

  async created() {
    try {
      let res = await getDetail({
        storeId: this.$store.state.account.storeId,
        storeName: this.$store.state.base.storeName,
        id: this.$route.params.eventId || this.$route.query.eventId,
      });

      (this.id = res.id),
      // 活动名称
      (this.name = res.name),
      // 活动详情
      (this.detail = res.detail);
      // 开始时间
      this.startTime = String(res.startTime).slice(0, 16);
      // 结束时间
      this.endTime = String(res.endTime).slice(0, 16);
      // 活动头图
      this.headDiagram = res.headDiagram;
      // 活动链接
      this.link = res.link;
      // 活动地址
      this.address = res.address || '';
      // 下方方式
      this.way = 1; //res.way

      // console.log(res)
    } catch (error) {
      Toast({
        message: error.message || '获取活动详情失败',
        duration: 1000,
        position: 'top',
      });
    }
  },

  mounted() {},

  destroyed() {},

  methods: {
    goRegister() {
      this.$router.push({ name: 'plazaActivityReg', params: { id: this.id } });
    },
  },
};
</script>

<style lang="less" scoped>
.bs-wrapper {
  padding-top: 10px;
  max-height: calc(100% - 74px);
  overflow: auto;
  /*解决ios上滑动不流畅*/
  -webkit-overflow-scrolling: touch;
}
.activity-wrapper {
  margin-left: 10px;
  width: 355px;
  margin-bottom: 74px;
}
.section3 {
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.06);
  align-self: center;
  width: 355px;
  justify-content: flex-start;
  padding-top: 16px;
  padding-bottom: 40px;
  align-items: center;
  .main1 {
    width: 327px;
    // height: 439px;
    .main2 {
      position: relative;
      width: 327px;
      height: 163px;
      border-radius: 8px;
      overflow: hidden;
      .section4 {
        height: 163px;
        width: 327px;
        justify-content: flex-end;
        align-items: flex-start;
        position: absolute;
        left: 0;
        top: 0;
      }
      .head-img {
        display: block;
        width: 327px;
        height: 163px;
        background: #d8d8d8;
        border-radius: 8px;
        overflow: hidden;
      }
    }
    .main3 {
      width: 330px;
      margin-top: 20px;
      justify-content: flex-start;
      .word3 {
        width: 56px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        white-space: nowrap;
        line-height: 20px;
        text-align: left;
      }
      .info3 {
        width: 274px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
        white-space: normal;
        word-break: break-all;
        line-height: 20px;
        text-align: left;
        padding-left: 12px;
      }
    }
    .main6 {
      width: 327px;
      // height: 160px;
      margin-top: 12px;
      justify-content: space-between;
      .word7 {
        width: 56px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        white-space: nowrap;
        line-height: 20px;
        text-align: left;
      }
      .word8 {
        width: 259px;
        // height: 160px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
        line-height: 20px;
        text-align: justify;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.section5 {
  position: fixed;
  bottom: 0px;
  height: 44px;
  border-radius: 22px;
  box-shadow: 0px 3px 12px 1px rgba(228, 19, 53, 0.35);
  background: #FF6F00;
  align-self: center;
  margin-left: 10px;
  margin-top: 38px;
  width: 355px;
  justify-content: center;
  align-items: center;
  .word9 {
    z-index: 48;
    width: 64px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 22px;
    text-align: center;
  }
}
.iframeContain {
  height: calc(100% - 8px);
  overflow: auto;
  iframe {
    width: 355px;
    border: none;
    height: calc(100% - 28px);
  }
}
</style>
